export default __webpack_public_path__ + "static/media/pinterest.aa088d9c.svg";